import { useState, useCallback } from 'react';
import { loadProUnlock, saveProUnlock, ProUnlock } from '@/lib/pro';

export function usePro() {
  const [unlock, setUnlock] = useState<ProUnlock | null>(() => loadProUnlock());

  const isPro = unlock !== null;

  const activatePro = useCallback((txid: string) => {
    const record: ProUnlock = { txid, unlockedAt: Date.now() };
    saveProUnlock(record);
    setUnlock(record);
  }, []);

  return { isPro, unlock, activatePro };
}
